"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProductsFieldsValue = exports.getProductsFieldsValues = exports.getProductsFieldsValueById = exports.deleteProductsFieldsValue = exports.defaultProductsFieldsValueData = exports.createProductsFieldsValues = exports.createProductsFieldsValue = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultProductsFieldsValueData = exports.defaultProductsFieldsValueData = {
  id: 0,
  enabled: true,
  value: 0,
  productsFieldId: undefined,
  productsField: {
    id: undefined
  }
};
const getProductsFieldsValues = params => (0, _request.default)({
  url: '/products-fields-values',
  method: 'get',
  params
});
exports.getProductsFieldsValues = getProductsFieldsValues;
const getProductsFieldsValueById = id => (0, _request.default)({
  url: `/products-fields-values/${id}`,
  method: 'get'
});
exports.getProductsFieldsValueById = getProductsFieldsValueById;
const updateProductsFieldsValue = (id, data) => (0, _request.default)({
  url: `/products-fields-values/${id}`,
  method: 'patch',
  data
});
exports.updateProductsFieldsValue = updateProductsFieldsValue;
const deleteProductsFieldsValue = id => (0, _request.default)({
  url: `/products-fields-values/${id}`,
  method: 'delete'
});
exports.deleteProductsFieldsValue = deleteProductsFieldsValue;
const createProductsFieldsValue = data => (0, _request.default)({
  url: '/products-fields-values/',
  method: 'post',
  data
});
exports.createProductsFieldsValue = createProductsFieldsValue;
const createProductsFieldsValues = data => (0, _request.default)({
  url: '/products-fields-values/bulk',
  method: 'post',
  data
});
exports.createProductsFieldsValues = createProductsFieldsValues;